import {
  EncounterChannel,
  EncounterDirection,
  EncounterEscalatedReason,
  EncounterMethod,
  EncounterMethodOutcome,
  EncounterType,
} from '../enums';
import { Employee } from './Employee';
import { make } from './Model';

export class Encounter {
  callbackDateTime = 0;

  direction?: EncounterDirection;

  method?: EncounterMethod;

  methodOutcome?: EncounterMethodOutcome;

  source = '';

  channel: EncounterChannel;

  createdBy: Employee;

  duration = 0;

  encounterDate = '';

  encounterDateTime = 0;

  escalatedTo?: Employee;

  escalationReason?: EncounterEscalatedReason;

  escalationReasonOther = '';

  eventId?: number;

  id = 0;

  note?: string;

  otherChannel?: string;

  type?: EncounterType;

  createdAt = 0;

  valid = true;

  invalidatedAt = 0;

  careTeamMemberId?: number;

  communityResourceId?: number;

  programTaskId?: number;

  taskId?: number;

  transferredTo?: Employee;

  skilledRecordId?: number;

  tocRecordId?: number;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.channel = EncounterChannel.byKey[obj.channel];
    this.createdBy = make(obj.createdBy, Employee);
    this.direction = obj.direction && EncounterDirection.byKey[obj.direction];
    this.escalationReason =
      obj.escalationReason &&
      EncounterEscalatedReason.byKey[obj.escalationReason];
    this.escalatedTo = make(obj.escalatedTo, Employee);
    this.method = obj.method && EncounterMethod.byKey[obj.method];
    this.methodOutcome =
      obj.methodOutcome && EncounterMethodOutcome.byKey[obj.methodOutcome];
    this.transferredTo = make(obj.transferredTo, Employee);
    this.type = obj.type && EncounterType.byKey[obj.type];
  }

  get displayChannel() {
    return this.channel.isOther
      ? `${this.channel.toString()} - ${this.otherChannel}`
      : this.channel.toString();
  }
}
